import React, { useEffect, useState } from 'react'
import { Button, Form, Nav } from 'react-bootstrap'
import { FaRegSquarePlus } from "react-icons/fa6";
import * as yup from 'yup';
import { useFormik } from 'formik';
import toast from 'react-hot-toast'
import moment from 'moment';
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { Box, Paper, Tooltip } from "@mui/material";
import DataTable from "react-data-table-component";
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import { getSubCategoryListing } from '../../api/context/subcategory';
import Loader from '../../components/loader/loader';
import { checkUserPermissions } from '../../helpers/permission';
import { useNavigate } from 'react-router-dom';
import { deleteManufacture, getAllManufactures } from '../../api/context/manufacturer';
import { IoSearchOutline } from 'react-icons/io5';
import { alignPropType } from 'react-bootstrap/esm/types';
import { FiEdit, FiPlus, FiRefreshCcw, FiRefreshCw, FiTrash2 } from 'react-icons/fi';

const queueDatatableCustomStyles = {
    tableWrapper: {
        style: {
            display: 'block',
            width: '100%',
        },
    },
    table: {
        style: {
            width: '100%',
            minWidth: '100%',
        },
    },
    headRow: {
        style: {
            width: '100%',
        },
    },
    rows: {
        style: {
            width: '100%',
        },
    },
    headCells: {
        style: {
            display: "flex",
            justifyContent: "center",
            fontWeight: '600',
            fontSize: '8px',
            padding: '8px 4px',
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
            color: '#475569',
            backgroundColor: '#f9f9f9ff',
        },
    },
    cells: {
        style: {
            display: "flex",
            fontSize: '9px',
            fontWeight: '500',
            padding: '6px 4px',
            color: '#0f172a',
        },
    },
};

const Manufacturer = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [update, setUpdate] = useState(false)
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState('');
    const [initial, setInitial] = useState(false)
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [sortBy, setSortBy] = useState('createdAt');
    const [sortDirection, setSortDirection] = useState('DESC');
    const [activeTab, setActiveTab] = useState('verified');
    const [isInitialRender, setIsInitialRender] = useState(true);

    const toggleModal = () => {
        setModal(!modal);
    };

    const columns = [
        {
            name: "Image",
            cell: (row) => {
                const platform = row?.externalPlatform?.toLowerCase();
                const platformData = {
                    'woocommerce': { initial: 'W', color: '#96588a' },
                    'shopify': { initial: 'S', color: '#5e8e3e' },
                    'magento': { initial: 'M', color: '#f46f25' },
                };
                const platformInfo = platformData[platform];
                return row?.image ? (
                    <img
                        src={row.image}
                        alt={row?.storeName || 'vendor'}
                        style={{
                            width: '32px',
                            height: '32px',
                            borderRadius: '4px',
                            objectFit: 'cover',
                            border: '1px solid #e2e8f0',
                            background: '#f8fafc',
                        }}
                        onError={(e) => { e.currentTarget.style.display = 'none'; }}
                    />
                ) : (
                    <div style={{
                        width: '32px',
                        height: '32px',
                        borderRadius: '4px',
                        background: '#f1f5f9',
                        border: `1px solid ${platformInfo?.color || '#e2e8f0'}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: platformInfo?.color || '#64748b',
                        fontSize: '11px',
                        fontWeight: 700,
                    }}>
                        {platformInfo ? platformInfo.initial : (row?.storeName?.charAt(0)?.toUpperCase() || 'V')}
                    </div>
                );
            },
            minWidth: '60px',
            grow: 1,
            center: true,
            ignoreRowClick: false,
        },
        {
            id: 'storeName',
            name: 'Store',
            selector: (row) => row?.storeName,
            cell: (row) => (
                <Tooltip title={row?.storeName} disableInteractive placement='top'>
                    <div
                        style={{
                            width: '100%',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textDecoration: 'underline',
                            textUnderlineOffset: '2px',
                            textDecorationThickness: '1px',
                            textDecorationColor: '#a94b4bff',
                            textAlign: 'center',
                        }}
                        onClick={() => navigate('/edit-vendors/' + row.id)}
                    >
                        {row?.storeName}
                    </div>
                </Tooltip>
            ),
            sortable: true,
            minWidth: '100px',
            grow: 1,
            center: true,
        },
        {
            id: 'ownerName',
            name: 'Owner',
            selector: (row) => row?.ownerName,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        width: '100%',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.ownerName} disableInteractive placement='top'>
                        <div>{row?.ownerName}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            minWidth: '70px',
            grow: 1,
            center: true,
        },
        {
            id: 'address',
            name: 'Address',
            selector: (row) => row?.address,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        maxWidth: '100%',
                        width: '100%',
                        margin: '0 auto',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.address} disableInteractive placement="top">
                        <div>{row?.address}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            minWidth: '100px',
            grow: 1,
            center: true,
        },
        {
            id: 'phoneNumber',
            name: ' Contact No',
            selector: (row) => row?.phoneNumber,
            cell: (row) => (
                <div
                    className="text-center text-truncate"
                    style={{
                        width: '100%',
                        cursor: 'pointer',
                        padding: '8px'
                    }}
                    onClick={() => navigate('/edit-vendors/' + row.id)}
                >
                    <Tooltip title={row?.phoneNumber} disableInteractive placement='top'>
                        <div>{row?.phoneNumber}</div>
                    </Tooltip>
                </div>
            ),
            sortable: true,
            minWidth: '140px',
            grow: 1,
            center: true,
        },
        {
            name: "ACTION",
            cell: (row) => (
                <div
                    className="d-flex justify-content-center"
                    onClick={(e) => e.stopPropagation()} // Prevent row click when clicking actions
                >
                    <div className='d-flex flex-row gap-3' role='button'>
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <div
                                className="edit_icon_bg"
                                onClick={() => navigate('/edit-vendors/' + row.id)}
                            >
                                <FiEdit size={10} className="edit_icon text-white" />
                            </div>
                        </Tooltip>
                        <Tooltip title="Sync" disableInteractive placement="top">
                            <div
                                className="edit_icon_bg"
                                onClick={() => navigate('/sync-inventory/' + row.id)}
                            >
                                <FiRefreshCw size={10} className="edit_icon text-white" />
                            </div>
                        </Tooltip>
                        <Tooltip title="Delete" disableInteractive placement="top">
                            <div
                                className="delete_icon_bg"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleConfirm(row?.id);
                                }}
                            >
                                <FiTrash2 size={10} className="delete_icon text-black" />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            ),
            minWidth: '180px',
            grow: 1,
            center: true,
            ignoreRowClick: true, // Prevent row click for this column
        },
    ];




    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    }

    const deleteManufactures = (id) => {
        deleteManufacture(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setUpdate(!update);
                setModal(!modal);
                toast.success("Vendor deleted successfully")
            } else {
                toast.error(response?.data?.message);
            }
        });
    }

    const getManufactureData = async () => {
        setLoading(true);
        getAllManufactures({
            page: page,
            pageSize: limit,
            search: search,
            sortBy: sortBy,
            sortDirection: sortDirection,
            isVerified: activeTab === 'verified' ? true : false,
        })((response) => {
            if (response?.statusCode == 200) {
                setData(response?.data?.manufacturers);
                setTotalRows(response?.data?.totalCount);
                setLoading(false);
            } else {
                setData([]);
                setLoading(false);
            }
        });
    }

    useEffect(() => {
        getManufactureData();
        setIsInitialRender(false);
    }, [update, page, limit, sortBy, sortDirection]);

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) setUpdate(!update);
            else setInitial(true);
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    const handleSort = (column, sortDirection) => {
        setSortBy(column.id);
        setSortDirection(sortDirection);
        setUpdate(!update);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (page) => {
        setPage(page);
        setUpdate(!update);
    };

    useEffect(() => {
        if (!isInitialRender) {
            setPage(1); // Reset to first page when changing tabs
            getManufactureData();
        }
    }, [activeTab]);

    return (
        <div className="vendors-page">
            <style>{`
                /* Hide the global topbar on this page — the page header replaces it */
                body:has(.vendors-page) #page-topbar { display: none !important; }
                body:has(.vendors-page) .page-content {
                    padding-top: 0 !important;
                    padding-bottom: 24px !important;
                }

                /* Page header pinned at the top */
                .vendors-page .page-header-sticky {
                    position: fixed !important;
                    top: 0 !important;
                    left: var(--vz-vertical-menu-width, 208px) !important;
                    right: 0 !important;
                    width: auto !important;
                    padding: 18px clamp(20px, 3vw, 48px) !important;
                    margin: 0 !important;
                    background: #f9fafb !important;
                    border-bottom: 1px solid #e5e7eb !important;
                    z-index: 1050 !important;
                }
                .vendors-page .page-header-sticky h3 { font-size: 18px !important; margin: 0 !important; }
                .vendors-page { padding-top: 72px !important; }

                /* Compact action button */
                .vendors-page .vnd-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 6px 18px !important;
                    border-radius: 4px !important;
                    font-size: 12px !important;
                    font-weight: 500 !important;
                    height: 34px;
                    white-space: nowrap;
                    transition: all 0.15s ease;
                    border: 1px solid #008695;
                    background: #008695;
                    color: #fff;
                    cursor: pointer;
                }
                .vendors-page .vnd-btn:hover {
                    background: #006672;
                    border-color: #006672;
                    color: #fff;
                }
                .vendors-page .vnd-btn svg { width: 14px; height: 14px; }

                /* Search input */
                .vendors-page .vnd-search-input {
                    border: 1px solid #e2e8f0 !important;
                    border-radius: 4px !important;
                    padding: 6px 12px !important;
                    font-size: 12px !important;
                    height: 34px !important;
                    background: #fff !important;
                    color: #0f172a !important;
                }
                .vendors-page .vnd-search-input:focus {
                    border-color: #008695 !important;
                    box-shadow: 0 0 0 3px rgba(0,134,149,0.15) !important;
                    outline: none;
                }

                /* Toolbar: search + tabs in a single row */
                .vendors-page .vnd-toolbar {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    margin: 0 0 10px 0;
                    flex-wrap: nowrap;
                }
                .vendors-page .vnd-toolbar .vnd-search {
                    flex: 1 1 auto;
                    min-width: 0;
                }

                /* Tabs */
                .vendors-page .vnd-tabs {
                    display: inline-flex;
                    gap: 4px;
                    background: #f1f5f9;
                    padding: 4px;
                    border-radius: 8px;
                    flex-shrink: 0;
                }
                .vendors-page .vnd-tab {
                    padding: 6px 16px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    background: transparent;
                    border: none;
                    border-radius: 6px;
                    cursor: pointer;
                    transition: color 0.15s ease, background 0.15s ease;
                    white-space: nowrap;
                }
                .vendors-page .vnd-tab.active {
                    background: #fff;
                    color: #008695;
                    box-shadow: 0 1px 3px rgba(15,23,42,0.08);
                }

                /* Shrink action-cell icon tiles (custom.scss forces them to 20px / 12px padding) */
                .vendors-page .edit_icon_bg,
                .vendors-page .delete_icon_bg {
                    padding: 5px !important;
                    border-radius: 4px !important;
                }
                .vendors-page .edit_icon_bg .edit_icon,
                .vendors-page .delete_icon_bg .delete_icon {
                    width: 11px !important;
                    height: 11px !important;
                }
                .vendors-page .edit_icon_bg:hover,
                .vendors-page .delete_icon_bg:hover { transform: none !important; box-shadow: none !important; }

                /* Mobile card grid + pagination bar — hidden on desktop */
                .vendors-page .vendors-mobile-list { display: none; }
                .vendors-page .vnd-mobile-add-bar { display: none; }
                .vendors-page .vendors-mobile-pagination { display: none; }

                @media (max-width: 991px) {
                    .vendors-page .page-header-sticky { padding: 16px 20px !important; }
                }
                @media (max-width: 767.98px) {
                    /* Keep the mobile top-bar (Getto logo + menu) visible on this page */
                    body:has(.vendors-page) .main-content { padding-top: 0 !important; }
                    .vendors-page .page-header-sticky {
                        left: 0 !important;
                        right: 0 !important;
                        top: 52px !important;
                        padding: 12px 14px !important;
                        gap: 8px !important;
                    }
                    .vendors-page { padding-top: 104px !important; padding-bottom: 76px !important; }

                    /* Trim outer horizontal padding on mobile so cards use more room */
                    body:has(.vendors-page) .page-content {
                        padding-left: 10px !important;
                        padding-right: 10px !important;
                    }
                    body:has(.vendors-page) .container,
                    body:has(.vendors-page) .container-fluid {
                        padding-left: 0 !important; padding-right: 0 !important;
                    }
                    .vendors-page .row { margin-left: 0 !important; margin-right: 0 !important; }
                    .vendors-page .row > [class*="col-"] { padding-left: 0 !important; padding-right: 0 !important; }

                    .vendors-page .page-header-sticky h3 { font-size: 15px !important; }
                    /* Header "Add Vendor" collapses to a compact icon-only button */
                    .vendors-page .page-header-sticky .vnd-btn {
                        width: 34px !important;
                        padding: 0 !important;
                        justify-content: center;
                    }
                    .vendors-page .page-header-sticky .vnd-btn-label { display: none !important; }
                    .vendors-page .page-header-sticky .vnd-btn svg { width: 14px; height: 14px; }

                    .vendors-page .vnd-toolbar { gap: 8px; }
                    .vendors-page .vnd-tabs { padding: 3px; gap: 2px; }
                    .vendors-page .vnd-tab { padding: 5px 10px; font-size: 11px; }

                    /* Swap the table for a card list */
                    .vendors-page .products-and-options { display: none !important; }
                    .vendors-page .vendors-mobile-list {
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                        padding: 8px 0 calc(60px + env(safe-area-inset-bottom, 0px));
                    }

                    /* Fixed bottom pagination bar */
                    .vendors-page .vendors-mobile-pagination {
                        display: flex !important;
                        position: fixed;
                        left: 0; right: 0; bottom: 0;
                        padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
                        background: #fff;
                        border-top: 1px solid #e2e8f0;
                        box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                        z-index: 1049;
                        align-items: center;
                        justify-content: space-between;
                        gap: 10px;
                    }
                    .vendors-page .vmp-btn {
                        width: 40px; height: 36px;
                        border-radius: 6px;
                        border: 1px solid #e2e8f0;
                        background: #fff;
                        color: #0f172a;
                        font-size: 16px; font-weight: 700;
                        cursor: pointer;
                        display: inline-flex; align-items: center; justify-content: center;
                        transition: all 0.15s ease;
                    }
                    .vendors-page .vmp-btn:hover:not(:disabled) {
                        border-color: #008695; color: #008695; background: rgba(0,134,149,0.06);
                    }
                    .vendors-page .vmp-btn:disabled { opacity: 0.35; cursor: not-allowed; }
                    .vendors-page .vmp-info {
                        font-size: 11px; color: #475569;
                        display: inline-flex; align-items: baseline; gap: 4px;
                        flex: 1; justify-content: center; text-align: center;
                    }
                    .vendors-page .vmp-info strong { color: #008695; font-weight: 700; }
                    .vendors-page .vmp-total { color: #94a3b8; font-size: 10px; }

                    /* Compact card padding for mobile so content aligns tight */
                    .vendors-page .vendor-card {
                        padding: 10px !important;
                        gap: 5px !important;
                    }

                    /* Hide the old bottom Add bar */
                    .vendors-page .vnd-mobile-add-bar { display: none !important; }
                }

                /* Vendor mobile card */
                .vendors-page .vendor-card {
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 8px;
                    padding: 12px;
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    transition: transform 0.12s ease, border-color 0.15s ease;
                }
                .vendors-page .vendor-card:active { transform: scale(0.99); border-color: #008695; }
                .vendors-page .vendor-card-main {
                    display: flex;
                    align-items: flex-start;
                    gap: 12px;
                }
                .vendors-page .vendor-card-image {
                    width: 68px;
                    height: 68px;
                    border-radius: 8px;
                    object-fit: cover;
                    background: #f1f5f9;
                    border: 1px solid #e2e8f0;
                    flex-shrink: 0;
                    display: block;
                }
                .vendors-page .vendor-card-image-fallback {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 22px;
                    font-weight: 700;
                    color: #64748b;
                }
                .vendors-page .vendor-card-info {
                    flex: 1;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }
                .vendors-page .vendor-card-name {
                    font-size: 13px;
                    font-weight: 700;
                    color: #0f172a;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    letter-spacing: -0.01em;
                }
                .vendors-page .vendor-card-line {
                    font-size: 11px;
                    color: #475569;
                    line-height: 1.35;
                }
                .vendors-page .vendor-card-address {
                    color: #64748b;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }
                .vendors-page .vendor-card-actions {
                    display: flex;
                    gap: 8px;
                    justify-content: flex-end;
                    border-top: 1px solid #eef2f7;
                    padding-top: 8px;
                    margin-top: 2px;
                }
                .vendors-page .vendor-card-action {
                    width: 30px; height: 30px;
                    border-radius: 6px;
                    display: inline-flex;
                    align-items: center; justify-content: center;
                    cursor: pointer;
                    transition: all 0.15s ease;
                }
                .vendors-page .vendor-card-action svg { width: 13px; height: 13px; }
                .vendors-page .vendor-card-action.vc-edit { background: rgba(0,134,149,0.1); color: #008695; }
                .vendors-page .vendor-card-action.vc-edit:hover { background: #008695; color: #fff; }
                .vendors-page .vendor-card-action.vc-sync { background: rgba(99,102,241,0.1); color: #6366f1; }
                .vendors-page .vendor-card-action.vc-sync:hover { background: #6366f1; color: #fff; }
                .vendors-page .vendor-card-action.vc-delete { background: rgba(220,38,38,0.1); color: #dc2626; }
                .vendors-page .vendor-card-action.vc-delete:hover { background: #dc2626; color: #fff; }
                .vendors-page .vendor-card-empty {
                    text-align: center;
                    padding: 32px 12px;
                    color: #94a3b8;
                    font-size: 12px;
                }
            `}</style>

            <div className="row">
                <div className="col-12">
                    <div className="page-header-sticky d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <h3 className="mb-0 fw-bolder">Vendors</h3>

                        {checkUserPermissions('manage_manufacturer') && (
                            <button
                                type="button"
                                className="vnd-btn"
                                onClick={() => navigate('/create-vendors')}
                            >
                                <FiPlus />
                                <span className="vnd-btn-label">Add New Vendor</span>
                            </button>
                        )}
                    </div>
                </div>

                <div className="col-12">
                    <div className="vnd-toolbar">
                        <Form.Control
                            type="text"
                            placeholder="Search for vendors..."
                            className="vnd-search-input vnd-search"
                            onChange={(e) => setSearch(e.target.value.trim())}
                        />
                        <div className="vnd-tabs">
                            <button
                                type="button"
                                className={`vnd-tab ${activeTab === 'verified' ? 'active' : ''}`}
                                onClick={() => setActiveTab('verified')}
                            >
                                Verified
                            </button>
                            <button
                                type="button"
                                className={`vnd-tab ${activeTab === 'notVerified' ? 'active' : ''}`}
                                onClick={() => setActiveTab('notVerified')}
                            >
                                Not verified
                            </button>
                        </div>
                    </div>
                </div>

                <CustomisedModal
                        isOpen={modal}
                        customClass={"policy_modal"}
                        toggle={toggleModal}
                    >
                        <h5>Are you sure you want to remove this item?</h5>
                        <div className="policy_Agree">
                            <Button
                                onClick={() => setModal(!modal)}
                                size="lg"
                                className='btn_cancel'
                            >
                                Cancel
                            </Button>
                            <Button
                                size="lg"
                                className='btn'
                                onClick={() => deleteManufactures(deletingId)}
                            >
                                Delete
                            </Button>
                        </div>
                    </CustomisedModal>

                <div className="col-12">
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border border-blue-grey-200'>
                            <div>
                                <DataTable
                                    columns={columns}
                                    pointerOnHover
                                    highlightOnHover
                                    data={data}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalRows}
                                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    onSort={handleSort}
                                    sortServer
                                    currentPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                />
                            </div>
                        </Paper>
                    </Box>

                    {/* Mobile card list */}
                    <div className="vendors-mobile-list">
                        {loading ? (
                            <div style={{ height: '40vh' }}><Loader /></div>
                        ) : data && data.length > 0 ? (
                            data.map((row) => {
                                const platform = row?.externalPlatform?.toLowerCase();
                                const platformData = {
                                    woocommerce: { initial: 'W', color: '#96588a' },
                                    shopify: { initial: 'S', color: '#5e8e3e' },
                                    magento: { initial: 'M', color: '#f46f25' },
                                };
                                const platformInfo = platformData[platform];
                                return (
                                    <div
                                        key={row.id}
                                        className="vendor-card"
                                        onClick={() => navigate('/edit-vendors/' + row.id)}
                                    >
                                        <div className="vendor-card-main">
                                            {/* Image on the left */}
                                            {row?.image ? (
                                                <img
                                                    src={row.image}
                                                    alt={row?.storeName || 'vendor'}
                                                    className="vendor-card-image"
                                                    onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                                />
                                            ) : (
                                                <div
                                                    className="vendor-card-image vendor-card-image-fallback"
                                                    style={platformInfo ? {
                                                        color: platformInfo.color,
                                                        borderColor: platformInfo.color,
                                                    } : undefined}
                                                >
                                                    {platformInfo ? platformInfo.initial : (row?.storeName?.charAt(0)?.toUpperCase() || 'V')}
                                                </div>
                                            )}

                                            {/* Info stack on the right */}
                                            <div className="vendor-card-info">
                                                <div className="vendor-card-name">{row?.storeName}</div>
                                                <div className="vendor-card-line">{row?.phoneNumber || '—'}</div>
                                                <div className="vendor-card-line vendor-card-address">
                                                    {row?.address || '—'}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="vendor-card-actions" onClick={(e) => e.stopPropagation()}>
                                            <div
                                                className="vendor-card-action vc-edit"
                                                onClick={() => navigate('/edit-vendors/' + row.id)}
                                                title="Edit"
                                            >
                                                <FiEdit />
                                            </div>
                                            <div
                                                className="vendor-card-action vc-sync"
                                                onClick={() => navigate('/sync-inventory/' + row.id)}
                                                title="Sync"
                                            >
                                                <FiRefreshCw />
                                            </div>
                                            <div
                                                className="vendor-card-action vc-delete"
                                                onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                                                title="Delete"
                                            >
                                                <FiTrash2 />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="vendor-card-empty">No vendors found</div>
                        )}
                    </div>
                </div>
            </div>

            {/* Mobile-only fixed pagination bar */}
            {(() => {
                const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
                const canPrev = page > 1;
                const canNext = page < totalPages;
                return (
                    <div className="vendors-mobile-pagination">
                        <button
                            type="button"
                            className="vmp-btn"
                            onClick={() => canPrev && handlePageChange(page - 1)}
                            disabled={!canPrev}
                            aria-label="Previous page"
                        >
                            ←
                        </button>
                        <span className="vmp-info">
                            Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                            <span className="vmp-total">· {totalRows || 0}</span>
                        </span>
                        <button
                            type="button"
                            className="vmp-btn"
                            onClick={() => canNext && handlePageChange(page + 1)}
                            disabled={!canNext}
                            aria-label="Next page"
                        >
                            →
                        </button>
                    </div>
                );
            })()}
        </div>
    )
}

export default Manufacturer;